<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $t('messages.settings'),
                        href: null,
                    },
                ]"
            />
        </template>
        <form method="POST" :action="meta.links.update" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    {{ $tc('messages.languages', 1) }}
                </template>
                <div class="md:grid md:grid-cols-6 md:gap-6">
                    <div class="sm:col-span-3">
                        <FormLabel :value="$tc('messages.languages', 1)" for="preferred_language" />
                        <div class="mt-1">
                            <FormSelect
                                required
                                id="preferred_language"
                                v-model="form.preferred_language"
                                :options="options.languages"
                                class="mt-1 w-full"
                                optgroups
                            />
                            <FormError :value="form.errors.preferred_language" class="mt-2" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <TitleFieldsFormSection>
                <template v-slot:title>
                    {{ $t('messages.change_password') }}
                </template>
                <div class="md:grid md:grid-cols-6 md:gap-6">
                    <div class="sm:col-span-3">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.password')" for="password" />
                            <FormInput
                                id="password"
                                v-model="form.password"
                                name="password"
                                autocomplete="new-password"
                                type="password"
                                max="191"
                                class="mt-1 w-full"
                            />
                            <FormError :value="form.errors.password" class="mt-2" />
                        </div>
                    </div>
                    <div class="sm:col-span-3">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.password_repeat')" for="password_confirmation" />
                            <FormInput
                                id="password_confirmation"
                                v-model="form.password_confirmation"
                                name="password_confirmation"
                                autocomplete="new-password"
                                type="password"
                                max="191"
                                class="mt-1 w-full"
                            />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <div>
                <div class="flex justify-end mt-5">
                    <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
                </div>
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';

export default {
    components: {
        TitleFieldsFormSection,
        FormInput,
        FormLabel,
        FormSelect,
        FormError,
        SubmitFormButton,
        PanelPage,
    },
    layout: Layout,
    name: 'Edit',
    props: ['meta', 'user', 'options'],
    data() {
        return {
            form: this.$inertia.form({
                preferred_language: this.user.preferred_language,
                password: null,
                password_confirmation: null,
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update, {
                onFinish: () => {
                    this.$i18n.locale = this.user.preferred_language;
                },
            });
        },
    },
};
</script>
